import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { OffcanvasOptions } from '../../../../../core/_base/layout';
import { TaskService } from '../../../../../core/timeline';

@Component({
  selector: 'kt-entity-details-offcanvas',
  templateUrl: './entity-details-offcanvas.component.html',
  styleUrls: ['./entity-details-offcanvas.component.scss'],
})
export class EntityDetailsOffcanvasComponent implements OnDestroy {
  entity;
  private subscriptions = new Subscription();

  offcanvasOptions: OffcanvasOptions = {
    overlay: true,
    baseClass: 'offcanvas',
    placement: 'right',
    closeBy: 'kt_entity_details_close',
    toggleBy: 'kt_entity_details_toggle',
  };

  constructor(private taskService: TaskService) {
    this.taskService.newEntity.asObservable().subscribe((entity) => {
      this.entity = entity;
    });
  }

  closeComponent(e) {
    if (e) {
      this.close();
    }
  }
  close() {
    document.getElementById('kt_entity_details_offcanvas').classList.remove('offcanvas-on');
    const overlay = document.getElementById('show-overlay');
    overlay?.removeAttribute('id');
    overlay?.setAttribute('id', 'hide-overlay');
    this.taskService.newEntity.next('');
    // Start: Remove the QueryParams from the URL for the entities
    const newUrl = window.location.pathname;
    window.history.replaceState({ path: newUrl }, '', newUrl);
    // End: Remove the QueryParams from the URL for the entities
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
